var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegisterBubleSecondFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 317 73"
    },
    viewBox: "0 0 317 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#bc0021}.st4{fill:#0a40a7}.st5{fill:#0c41a7}")), /*#__PURE__*/React.createElement("path", {
    d: "M44.2 34.8h183.3v3.4H44.2z",
    style: {
      opacity: 0.3,
      fill: "#0b41a6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 36.5,
    r: 36,
    style: {
      fill: "#cf1f2c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 36.5,
    r: 23.5,
    style: {
      fill: "#cf1f2c"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterBubleSecondFill);
export default __webpack_public_path__ + "static/media/register-buble-second-fill.debe8b68975508dd85505b649c0e511e.svg";
export { ForwardRef as ReactComponent };